@if (_highchartsOptions) {
  <highcharts-chart
    [ngClass]="{ 'grey-blur': isLoading, 'disabled-axis-labels': chartType === ChartType.Spider }"
    [Highcharts]="Highcharts"
    [options]="_highchartsOptions"
    style="height: 400px; display: block"
    (chartInstance)="emitChartInstance($event)"
  ></highcharts-chart>
}
@if (!isLoading && customLegend) {
  <div class="custom-legend">
    @for (element of customLegend; track element) {
      <span class="legend-el"
        ><div class="circle" [ngStyle]="{ backgroundColor: element.color }"></div>
        {{ element.text }}</span
      >
    }
  </div>
}
